import React from 'react'
import '../assets/css/contact.css'
import projectImage from '../assets/images/01_0.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook } from '@fortawesome/free-brands-svg-icons'
import {
  faEnvelope,
  faLocationDot,
  faPhone,
} from '@fortawesome/free-solid-svg-icons'
import { APIProvider, Map, AdvancedMarker } from '@vis.gl/react-google-maps'



const position = {
  lat: 14.987714524058777,
  lng: 102.10584183759265
}

const ContactScreen = ({ language }) => {
  return (
    <div className='contact-container'>
      <div className='image-container'>
        <img src={projectImage} alt='Project' className='projects-image' />
        <h1 className='projects-title contact-title'>
          {language === 'en' ? 'CONTACT' : 'ติดต่อเรา'}
        </h1>
      </div>
      <div className='contact-content'>

        <div className='contact-details'>
        <div className='contact-description'>
          <p className='text-3xl font-bold'>
            OUR CONTACT
          </p>
          </div>
          <div className='contact-item'>
            <FontAwesomeIcon icon={faPhone} size='2x' />
            <span className='contact-text text-2xl '>PHONE</span>
          </div>
          <span className='contact-detail text-xl'>061-6524514</span>
          <div className='contact-item'>
            <FontAwesomeIcon icon={faEnvelope} size='2x' />
            <span className='contact-text text-2xl'>EMAIL</span>
          </div>
          <span className='contact-detail text-xl'>
            commons.c2023@gmail.com
          </span>
          <div className='contact-item'>
          <FontAwesomeIcon icon={faFacebook} size='2x' />
          <span className='contact-text text-2xl'>FACEBOOK</span>
          </div>
          <span className='contact-detail text-xl'>
            <a href='https://www.facebook.com/share/MwudPVoUepQ52PKp/?mibextid=wwXIfr' target='blanks'>Commons Core</a>
          </span>
          <p className='text-3xl font-bold mt-10'>
            OUR LOCATION
          </p>
          <div className='contact-item'>
            <FontAwesomeIcon icon={faLocationDot} size='2x' />
            <span className='contact-text text-2xl'>ADDRESS</span>
          </div>
          
          <div className='w-3/4'>
            <p className='contact-detail text-xl'>
              185 ถนนกีฬากลาง ตำบลในเมือง
            </p>
            <p className='contact-detail text-xl'>อำเภอเมืองนครราชสีมา</p>
            <p className='contact-detail text-xl'>จ.นครราชสีมา 30000</p>
          </div>
        </div>
        <div className='map-container'>
          <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
            <Map
              // style={mapContainerStyle}
              className='map' 
              defaultCenter={position}
              defaultZoom={16}
              gestureHandling={'greedy'}
              disableDefaultUI={false}
              mapId={process.env.REACT_APP_GOOGLE_MAPS_MAP_ID}
            >
              <AdvancedMarker position={position} />
            </Map>
          </APIProvider>
          <div>
            <p className='text-x font-bold  text-right pr-10'>
              Map to Commons-Core Co., Ltd. :
              <a
                href='https://www.google.com/maps/place/185+ถนน+กีฬากลาง+ในเมือง+เมือง+นครราชสีมา+30000/@14.9876109,102.103283,17z/data=!3m1!4b1!4m6!3m5!1s0x31194c9d53be70bb:0x57814303fe20c6f2!8m2!3d14.9876109!4d102.1058633!16s%2Fg%2F11sn_6j3y9?authuser=0&entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D'
                target='_blank'
                rel='noreferrer'
                className='font-normal'
              >
                Click here
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactScreen
